import { Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-info-svg-icon',
  imports: [NgClass],
  templateUrl: './info-svg-icon.component.html',
  styleUrl: './info-svg-icon.component.css',
})
export class InfoSvgIconComponent {
  @Input({ required: true }) class!: string;
  @Input() fillColor = '#372121';
}
